import {formatInTimeZone, zonedTimeToUtc} from 'date-fns-tz';

export const browserTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export type DisplayedTime = {kind: 'local'; timeOfDay: string} | {kind: 'foreign'; timeOfDay: string; timezone: string};

// A schedule keeps its time as wall-clock time in the zone it was saved in. The drawer shows it in the
// viewer's zone, at today's offset. When that moves it onto another day, its weekdays and day rule would
// no longer read true, so the stored time is shown unconverted with its zone named instead.
export const displayedTime = (
	timeOfDay: string,
	storedZone: string,
	viewerZone: string,
	now: Date = new Date()
): DisplayedTime => {
	if (storedZone === viewerZone) {
		return {kind: 'local', timeOfDay};
	}
	const storedDay = formatInTimeZone(now, storedZone, 'yyyy-MM-dd');
	const instant = zonedTimeToUtc(`${storedDay}T${timeOfDay}:00`, storedZone);
	if (formatInTimeZone(instant, viewerZone, 'yyyy-MM-dd') !== storedDay) {
		return {kind: 'foreign', timeOfDay, timezone: storedZone};
	}
	return {kind: 'local', timeOfDay: formatInTimeZone(instant, viewerZone, 'HH:mm')};
};
